const MAX_ENTRIES = 150;

const cache = new Map<string, string>();   // url → blobUrl
const queue: string[] = [];                // insertion order for eviction
const pending = new Map<string, Promise<string>>();

function evictOldest(): void {
    const oldest = queue.shift();
    if (!oldest) return;
    const blobUrl = cache.get(oldest);
    if (blobUrl) URL.revokeObjectURL(blobUrl);
    cache.delete(oldest);
}

export async function getOrFetch(url: string): Promise<string> {
    if (cache.has(url)) return cache.get(url)!;

    if (!pending.has(url)) {
        const p = fetch(url)
            .then(r => r.blob())
            .then(blob => {
                if (cache.size >= MAX_ENTRIES) evictOldest();
                const blobUrl = URL.createObjectURL(blob);
                cache.set(url, blobUrl);
                queue.push(url);
                pending.delete(url);
                return blobUrl;
            })
            .catch(() => {
                pending.delete(url);
                return url;
            });
        pending.set(url, p);
    }

    return pending.get(url)!;
}
